import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Window, Wall } from 'types';

export const getWindows = async ({
  wallId,
}: {
  wallId: number;
}): Promise<Window[] | undefined> => {
  if (wallId < 1) return;
  const { data }: { data: Wall } = await axios.get(`/api/walls/${wallId}`);
  const { windows } = data || {};
  return windows as Window[];
};

type QueryFnType = typeof getWindows;

type UseSnapshotsOptions = {
  wallId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useWindows = ({ wallId, config }: UseSnapshotsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['windows', wallId],
    queryFn: () => getWindows({ wallId }),
    ...config,
  });
};
